import { UserInfoFragment } from '../../../Components/ProductFruits/ProductFruits.generated'

const mapEnquiryToPFUser = ({
  guestId,
  guest,
  country,
}: UserInfoFragment): ProductFruitsUser => ({
  username: guestId,
  email: guest?.email,
  firstname: guest?.firstName ?? '',
  lastname: guest?.lastName,
  role: 'guest',
  props: {
    country: country,
  },
})

export default mapEnquiryToPFUser
